module.exports = __webpack_public_path__ + "static/media/Group.c6f9d5bb.svg";